export function isNetworkError(error: unknown): boolean {
  if (error instanceof Error) {
    return (
      error.message.includes('Failed to fetch') ||
      error.message.includes('Network request failed') ||
      error.message.includes('NetworkError') ||
      error.message.includes('network timeout') ||
      error.message.includes('refused to connect') ||
      error.message.includes('Network Error') ||
      error.message.includes('Database error') ||
      error.message.includes('unexpected_failure') ||
      !navigator.onLine
    );
  }
  return !navigator.onLine;
}

export function isOffline(): boolean {
  return !navigator.onLine;
}

export function handleNetworkError(error: unknown, retryFn?: () => void, retryCount: number = 0): void {
  const MAX_RETRIES = 3;
  const RETRY_DELAY = 1000; // 1 second base delay

  if (isOffline()) {
    toast.error('You are offline. Please check your internet connection.', {
      id: 'offline-error'
    });
    return;
  }

  if (isNetworkError(error)) {
    const shouldRetry = retryCount < MAX_RETRIES && retryFn;
    const retryMessage = shouldRetry ? ' Retrying...' : '';
    
    toast.error(`Connection error. Please try again.${retryMessage}`, {
      id: 'network-error',
      duration: shouldRetry ? 2000 : 3000
    });

    if (shouldRetry) {
      // Exponential backoff
      const delay = RETRY_DELAY * Math.pow(2, retryCount);
      setTimeout(() => {
        retryFn();
      }, delay);
    }
  }
}